import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=f61de30a&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
import style0 from "./Product.vue?vue&type=style&index=0&id=f61de30a&prod&scoped=true&lang=css&"
import style1 from "./Product.vue?vue&type=style&index=1&id=f61de30a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61de30a",
  null
  
)

export default component.exports